import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import { FormControl, HelpBlock } from 'react-bootstrap';

const DATE_FORMAT = 'DD/MM/YYYY';

class Input extends React.Component {
  private element;

  public focus = () => {
    const node: any = ReactDOM.findDOMNode(this.element);

    node.focus();
  }

  private setElementFromRef = (element) => {
    this.element = element;
  }

  public render() {
    return (
      <FormControl {...this.props} ref={this.setElementFromRef}/>
    );
  }
}

const DatePickerControl = ({ input, placeholder, meta: { touched, error }, ...props }) => {
  const handleChange = (date) => {
    const momentDate = moment(date);

    input.onChange(momentDate.isValid() ? momentDate.format(DATE_FORMAT) : '');
  };

  return (
    <div className={touched && error ? 'has-error' : ''}>
      <DatePicker
        {...input}
        {...props}
        locale="en-gb"
        customInput={<Input/>}
        placeholder={placeholder}
        dateFormat={DATE_FORMAT}
        selected={input.value ? moment(input.value, DATE_FORMAT) : null}
        onChange={handleChange}
      />
      {touched && error && <HelpBlock>{error}</HelpBlock>}
    </div>
  );
};

export default DatePickerControl;
